import api from './apiClient';

export const raceSeriesAPI = {
  // Public
  getSeries: async () => {
    const response = await api.get('/api/series');
    return response.data;
  },
  getSeriesById: async (id) => {
    const response = await api.get(`/api/series/${id}`);
    return response.data;
  },
  // CMS
  getCmsSeries: async () => {
    const response = await api.get('/api/cms/series');
    return response.data;
  },
  getCmsSeriesById: async (id) => {
    const response = await api.get(`/api/cms/series/${id}`);
    return response.data;
  },
  createSeries: async (data) => {
    const response = await api.post('/api/cms/series', data);
    return response.data;
  },
  updateSeries: async (id, data) => {
    const response = await api.post(`/api/cms/series/${id}`, data);
    return response.data;
  },
  deleteSeries: async (id) => {
    await api.post(`/api/cms/series/${id}/delete`, {});
  },
};
